import { setMediaFilesDataProvider } from '../../actions/AccordionActions';
import durationUtils from '../utils/DurationUtils';
import appParameters from '../../components/utils/AppParameters';
import apiService from '../../services/ApiService';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import configuration from '../../constants/Configuration';
import platformDetection from '../../components/utils/PlatformDetection';
import storeManager from '../../store/StoreManager';

const populateMediaFilesUtils = {
    searchTime: 0,
    dispatch: undefined,
    contentItemIdForRecordedSound: undefined,

    parseMediaItems (items, dispatch, isSoundTab = false) {
        if (this.dispatch == undefined) {
            this.dispatch = dispatch;
            this.startMediaFilesRefreshTimer();
        }

        const mediaFilesdataProvider = this.getDataProvider(items);

        if (!dispatch)
            dispatch = this.dispatch;

        if (!dispatch) {
            this.dispatch = storeManager.getStore().dispatch;
            dispatch = this.dispatch;
        }

        if (appParameters.assignmentFolderId == -1) {
            const currentDataProvider = storeManager.getState().accordion.mediaFilesDataProvider;

            if (isSoundTab && (!currentDataProvider || (currentDataProvider && !currentDataProvider.imagesDataProvider))) {
                dispatch(setMediaFilesDataProvider({soundsDataProvider: mediaFilesdataProvider.soundsDataProvider}));
            } else {
                dispatch(setMediaFilesDataProvider({
                    imagesDataProvider: mediaFilesdataProvider.imagesDataProvider,
                    soundsDataProvider: mediaFilesdataProvider.soundsDataProvider,
                    videosDataProvider: mediaFilesdataProvider.videosDataProvider
                }));
            }
        } else {
            var self = this;

            apiServiceUtils.executeSafeApiCall(function() {
                apiService.loadAssignmentFolder(appParameters.submitId).then(result => {
                    const items = result.media;
                    const assignmentDataProvider = this.getDataProvider(items);

                    self.mixData(dispatch, mediaFilesdataProvider, assignmentDataProvider);
                });
            }.bind(this));
        }
    },
    mixData(dispatch, myMediaFilesDataProvider, assignmenFolderDataProvider) {
        const imagesDataProvider = [].concat(assignmenFolderDataProvider.imagesDataProvider, myMediaFilesDataProvider.imagesDataProvider);
        const soundsDataProvider = [].concat(assignmenFolderDataProvider.soundsDataProvider, myMediaFilesDataProvider.soundsDataProvider);
        const videosDataProvider = [].concat(assignmenFolderDataProvider.videosDataProvider, myMediaFilesDataProvider.videosDataProvider);

        dispatch(setMediaFilesDataProvider({imagesDataProvider: imagesDataProvider, soundsDataProvider: soundsDataProvider, videosDataProvider: videosDataProvider}));
    },
    getDataProvider(items) {
        if (!items)
            return [];

        var images = [];
        var sounds = [];
        var videos = [];
        let i, k;
        const monthsOfYear = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        const host = '';

        for (i=0; i<items.length; i++) {
            let element = {};
            element.title = items[i].title;
            element.status = items[i].status;

            if (items[i].type == 'contentimage') {
                element.contentItemId = items[i].id;
                element.href = `${host}/file/ci/${items[i].id}/img`;
                element.width = items[i].width;
                element.height = items[i].height;

                if (items[i].contentThumbURL)
                    element.thumb = items[i].contentThumbURL;
                else
                    element.thumb = `${host}/file/ci/${items[i].id}/thumb/aaa`;

                images.push(element);
            } else if (items[i].type == 'contentsound' || items[i].type == 'contentsoundrecording') {
                element.contentItemId = items[i].id;
                element.href = host+ `/file/ci/${items[i].id}/aaa`;

                if (items[i].duration != undefined) {
                    element.duration = durationUtils.transformDuration(items[i].duration);
                    element.durationInSeconds = parseFloat(items[i].duration / 1000);
                }

                if (items[i].type == 'contentsoundrecording')
                    element.isRecordedSound = true;
                else {
                    for (k=0; k<monthsOfYear.length; k++) {
                        if (element.title.indexOf(monthsOfYear[k]) != -1) {
                            element.isRecordedSound = true;
                            break;
                        }
                    }
                }

                if (element.duration)
                    sounds.push(element);
            } else if (items[i].type == 'contentvideoh264') {
                element.contentItemId = items[i].id;
                element.href = `${host}/file/ci/${items[i].id}/aaa`;

                if (items[i].contentThumbURL)
                    element.thumb = items[i].contentThumbURL;
                else
                    element.thumb = `${host}/file/ci/${items[i].id}/thumb/aaa`;

                if (items[i].duration != undefined) {
                    element.duration = durationUtils.transformDuration(items[i].duration);
                    element.durationInSeconds = parseFloat(items[i].duration / 1000);
                }

                videos.push(element);
            }
        }

        var dataProvider = {};

        dataProvider.imagesDataProvider = images;
        dataProvider.soundsDataProvider = sounds;
        dataProvider.videosDataProvider = videos;

        return dataProvider;
    },
    getImagesDataProviderForTest () {
        var array = [];
        var object;

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/74259683/img';
        object.thumb = 'http://stage.creaza.com/file/ci/74259683/thumb/aaa';
        object.title = 'Item1sssss';
        object.contentItemId = 12345;
        object.status = 'preparing';
        object.width = 200;
        object.height = 100;
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59618267/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59618267/thumb/aaa';
        object.title = 'Item2';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59613269/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59613269/thumb/aaa';
        object.title = 'Item3';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59613267/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59613267/thumb/aaa';
        object.title = 'Item4';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59606269/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59606269/thumb/aaa';
        object.title = 'Item5';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59609278/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59609278/thumb/aaa';
        object.title = 'Item6';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59609276/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59609276/thumb/aaa';
        object.title = 'Item7';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59606277/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59606277/thumb/aaa';
        object.title = 'Item8';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59606279/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59606279/thumb/aaa';
        object.title = 'Item9';
        array.push(object);

        object = {};
        object.href = 'http://stage.creaza.com/file/ci/59606281/img';
        object.thumb = 'http://stage.creaza.com/file/ci/59606281/thumb/aaa';
        object.title = 'Item10';
        array.push(object);

        array = array.concat(array);
        array = array.concat(array);
        array = array.concat(array);

        return array;
    },
    getSoundsDataProviderForTest () {
        var array = [];
        var object;

        object = {};
        object.duration = '01:21';
        object.title = 'Sound1 asda asd asdas asda';
        object.href='http://freesound.org/data/previews/405/405201_1106021-lq.mp3';
        object.contentItemId = 1;
        object.isRecordedSound = true;
        array.push(object);

        object = {};
        object.duration = '00:18';
        object.title = 'Sound2';
        object.href='http://soundbible.com/mp3/baby-music-box_daniel-simion.mp3';
        object.contentItemId = 2;
        array.push(object);

        object = {};
        object.duration = '00:11';
        object.title = 'Sound3';
        object.href='/file/ci/73563245/aaa';
        object.contentItemId = 3;
        array.push(object);

        object = {};
        object.duration = '00:29';
        object.title = 'Sound4';
        object.contentItemId = 4;
        array.push(object);

        object = {};
        object.duration = '01:12';
        object.title = 'Sound5';
        object.contentItemId = 5;
        object.isRecordedSound = true;
        array.push(object);

        object = {};
        object.duration = '03:52';
        object.title = 'Sound6';
        object.contentItemId = 6;
        array.push(object);

        object = {};
        object.duration = '01:02';
        object.title = 'Sound7';
        object.contentItemId = 7;
        array.push(object);

        object = {};
        object.duration = '03:41';
        object.title = 'Sound8';
        object.contentItemId = 8;
        object.isRecordedSound = true;
        array.push(object);

        object = {};
        object.duration = '03:33';
        object.title = 'Sound9';
        object.contentItemId = 9;
        array.push(object);


        object = {};
        object.duration = '04:22';
        object.title = 'Sound10';
        object.contentItemId = 10;
        array.push(object);

        object = {};
        object.duration = '01:21';
        object.title = 'Sound1 asda asd asdas asda';
        object.href='http://freesound.org/data/previews/405/405201_1106021-lq.mp3';
        object.contentItemId = 1;
        object.isRecordedSound = true;
        array.push(object);

        object = {};
        object.duration = '00:18';
        object.title = 'Sound2';
        object.href='http://soundbible.com/mp3/baby-music-box_daniel-simion.mp3';
        object.contentItemId = 2;
        array.push(object);

        object = {};
        object.duration = '00:11';
        object.title = 'Sound3';
        object.href='/file/ci/73563245/aaa';
        object.contentItemId = 3;
        array.push(object);

        object = {};
        object.duration = '00:29';
        object.title = 'Sound4';
        object.contentItemId = 4;
        array.push(object);

        object = {};
        object.duration = '01:12';
        object.title = 'Sound5';
        object.contentItemId = 5;
        object.isRecordedSound = true;
        array.push(object);

        object = {};
        object.duration = '03:52';
        object.title = 'Sound6';
        object.contentItemId = 6;
        array.push(object);

        object = {};
        object.duration = '01:02';
        object.title = 'Sound7';
        object.contentItemId = 7;
        array.push(object);

        object = {};
        object.duration = '03:41';
        object.title = 'Sound8';
        object.contentItemId = 8;
        object.isRecordedSound = true;
        array.push(object);

        object = {};
        object.duration = '03:33';
        object.title = 'Sound9';
        object.contentItemId = 9;
        array.push(object);


        object = {};
        object.duration = '04:22';
        object.title = 'Sound10';
        object.contentItemId = 10;
        array.push(object);

        return array;
    },
    getVideosDataProviderForTest () {
        var array = [];
        var object;

        object = {};
        object.title = 'Video1';
        object.status = 'preparing';
        object.href='https://stage.creaza.com/file/ci/75385873/aaa';
        object.thumb = 'http://stage.creaza.com/file/ci/75385873/thumb/aaa';
        object.contentItemId = 59820349;
        array.push(object);

        object = {};
        object.title = 'Roma';
        object.status = 'preparing';
        object.href='https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_roma_010.mp4';
        object.thumb = 'https://d3b76ijxom7qfl.cloudfront.net/staticthumbs/video/creaza_italia_roma_010.jpg';
        object.contentItemId = 75383569;
        array.push(object);

        return array;
    },

    // refresh MyMediaFiels with the new uploaded files

    mediaFilesRefreshTimer: undefined,
    checkStatusTimer: undefined,
    lastUploadedFileId: -1,
    extraTimer: undefined,
    currentRefreshTime: -1,

    stopRefreshTimers() {
        if (this.checkStatusTimer)
            clearInterval(this.checkStatusTimer);

        if (this.mediaFilesRefreshTimer)
            clearInterval(this.mediaFilesRefreshTimer);
    },
    startMediaFilesRefreshTimer() {
        // return; //removed this functionality for some performance tests

        if (configuration.LOAD_LOCAL == true)
            return;

        this.stopRefreshTimers();
        this.mediaFilesRefreshTimer = setInterval(this.onMediaFilesRefreshTimer.bind(this), 10 * 1000);  // intial 5 seconds
    },
    onMediaFilesRefreshTimer() {
        var self = this;

        apiServiceUtils.executeSafeApiCall(function () {
            apiService.getLastUploadedMediaFileId()
                .then(response => {
                    if (response && response.contentItemId > 0) {
                        self.lastUploadedFileId = response.contentItemId;
                        self.startCheckStatusForCurrentUpload();
                    }
                });
        }.bind(this), function() {
            this.stopRefreshTimers();
        }.bind(this));
    },
    startCheckStatusForCurrentUpload() {
        this.cleartExtraTimer();
        this.stopRefreshTimers();
        this.checkStatusTimer = setInterval(this.onCheckStatus.bind(this), 5 * 1000); // initial 2 seconds
    },
    onCheckStatus() {
        if (this.lastUploadedFileId < 0) {
            this.stopRefreshTimers();
            return;
        }

        var self = this;

        apiServiceUtils.executeSafeApiCall(function() {
            apiService.getUploadingMediaFileStatus(this.lastUploadedFileId)
                .then(response => {
                    var statusObject = response.status;

                    if (statusObject && (statusObject[self.lastUploadedFileId] == 'finished' || statusObject[self.lastUploadedFileId] == 'corrupt')) {
                        self.refreshMediaFiles();
                    }
                });

            apiService.getLastUploadedMediaFileId()
                .then(response => {
                    if (response && response.contentItemId == -1) { // no files to be loaded ... then a refresh should be done
                        self.refreshMediaFiles();
                    }
                });
        }.bind(this));
    },
    refreshMediaFiles() {
        this.lastUploadedFileId = -1;
        this.startMediaFilesRefreshTimer(); // check for another possible uploaded file

        apiServiceUtils.executeSafeApiCall(this.executeGetMediaFilesCall.bind(this));

        this.cleartExtraTimer();
        this.currentRefreshTime = new Date().getTime();
        this.extraTimer = setInterval(this.onExtraRefresh.bind(this), 7 * 1000);
    },
    onExtraRefresh() {
        apiServiceUtils.executeSafeApiCall(this.executeGetMediaFilesCall.bind(this));

        var currentTime = new Date().getTime();

        if ((currentTime - this.currentRefreshTime) > 2 * 60 * 1000)
            this.cleartExtraTimer();
    },
    cleartExtraTimer() {
        if (this.extraTimer)
            clearInterval(this.extraTimer);
    },
    executeGetMediaFilesCall() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    refreshMediaFilesAfterRecording() {
        this.executeGetMediaFilesCall();
    },
    cleanTimers() {
        this.stopRefreshTimers();
    },
    restartRefreshTimers() {
        setTimeout(this.startMediaFilesRefreshTimer.bind(this), 6 * 1000);
    }
};

export default populateMediaFilesUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/PopulateMediaFilesUtils.js
 **/